import { SectionStatus } from '@/api/characteristics/types';
import { IconCheckCircleMS, IconCircleMS } from '@/constants/icons';
import { alpha, Box } from '@mui/material';

import { StyledChip } from '../styles';

const statusConfig: Record<SectionStatus, { label: string; color: string }> = {
  complete: { label: 'Completo', color: '#23B45D' },
  partial: { label: 'Incompleto', color: '#FF6600' },
  pending: { label: 'Não iniciado', color: '#707070' },
};

interface SectionStatusBadgeProps {
  status?: SectionStatus;
}

export function SectionStatusBadge({
  status,
}: SectionStatusBadgeProps): JSX.Element | null {
  if (!status) return null;
  const { label, color } = statusConfig[status];

  return (
    <StyledChip
      label={label}
      size="small"
      sx={{
        color,
        backgroundColor: alpha(color, 0.1),
      }}
    />
  );
}

interface GroupStatusIconProps {
  isComplete: boolean;
}

export function GroupStatusIcon({
  isComplete,
}: GroupStatusIconProps): JSX.Element {
  return (
    <Box
      component="span"
      sx={{
        color: isComplete ? 'success.main' : 'warning.main',
        display: 'flex',
        alignItems: 'center',
        fontSize: 22,
      }}
    >
      {isComplete ? IconCheckCircleMS : IconCircleMS}
    </Box>
  );
}
